// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1343":"94c0f09e88bf684c","6533":"61b4c9334f43ec3a","13678":"57cb0da95d0342cc","73527":"acac0e276ea249dc","80082":"e8dec7efcdc6dc08"}[chunkId] + ".css";
};